window.addEventListener('load', () => {
  const teaser = document.querySelector('[data-teaser-widget]');
  const teaserStars = document.querySelector('.tt-c-rating.tt-c-teaser__rating');

  if (teaserStars) {
    teaser.classList.remove('hidden');
    teaser.classList.add('block');
  } else {
    const reviewsWidgetSection = document.querySelector('.tt-container')?.closest('.shopify-section');

    if (reviewsWidgetSection) {
      reviewsWidgetSection.classList.add('hidden');
    }
  }
});